import { Text } from '@nimbus-ds/components';
import { CurrencyType } from '@tiendanube/common';
import { DataList } from '@tiendanube/components';
import { CurrencyPrice } from 'commons/components';
import { OrderDiscountsInterface } from '../../../Orders/pages/hooks/useOrderDiscounts/useOrderDiscounts';

interface Attributes {
  currency: CurrencyType;
  discount: OrderDiscountsInterface;
}

function OrderDiscountAmountRow({
  discount,
  currency,
}: Readonly<Attributes>): JSX.Element | null {
  return (
    <DataList.Row id={discount.id} key={discount.id}>
      <DataList.Cell width={70}>
        <Text color="neutral-textHigh">{discount.name}</Text>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <CurrencyPrice
          price={discount.value}
          currency={currency}
          block
          textAlign="right"
          preFix={discount.prefix}
          appearance={discount.appearance}
        />
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderDiscountAmountRow;
